import { render } from "./ListsCompare.vue?vue&type=template&id=65f25c8a&scoped=true"
import script from "./ListsCompare.vue?vue&type=script&lang=js"
export * from "./ListsCompare.vue?vue&type=script&lang=js"

import "./ListsCompare.vue?vue&type=style&index=0&id=65f25c8a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kvr\\Documents\\git\\krovyaka_io_source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f25c8a"]])

export default __exports__